const CODE = {
    RCV_SUCCESS             : "200", // 성공
    RCV_WRONGINFO           : "301", // 잘못된 정보
    RCV_FAIL                : "400", // 실패
    RCV_UNAUTHORIZED        : "401", // 인증된 사용자가 아님
    RCV_ERROR               : "500", // 오류
}

export default CODE;